export default __webpack_public_path__ + "static/media/03.711326f0.jpg";